import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["platform", "type", "base", "user", "repo"];
import React from 'react';
import { Internal } from "../common/Base.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var License = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      platform = 'github',
      type = 'license',
      base = 'https://img.shields.io',
      user,
      repo
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var getUrl = () => {
    if (platform !== 'github') return '';
    return [base, platform, type, user, repo].join('/');
  };
  return /*#__PURE__*/_jsx(Internal, _extends({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
License.displayName = 'License';